import React, { useState, useEffect, useMemo } from 'react';
import { supabase } from '../supabase';

const C = {
  purple:"#691FB1", purpleLight:"#EDE7F6", purpleDark:"#736CCE",
  pink:"#FF357B", pinkLight:"#FFF0F5",
  green:"#27AE60", greenLight:"#EAFAF1",
  amber:"#F39C12", amberLight:"#FEF9E7",
  red:"#E74C3C", redLight:"#FDEDEC",
  blue:"#57B1DD", blueLight:"#E5F7FF",
  bg:"#F7F5FC", white:"#FFFFFF",
  text:"#1A1A2E", textMid:"#4A4A6A", textLight:"#8888AA", border:"#E4DEFA",
};
const F = "'DM Sans',sans-serif"; // COMPACT_DONE

const ESTADOS_LEAD = {
  nova:       { label:"Nova",        color:C.textMid,   bg:C.bg },
  contactada: { label:"Contactada",  color:C.blue,      bg:C.blueLight },
  orcamento:  { label:"Orçamento",   color:C.purple,    bg:C.purpleLight },
  ganha:      { label:"Ganha",       color:C.green,     bg:C.greenLight },
  perdida:    { label:"Perdida",     color:C.red,       bg:C.redLight },
};

const inp = { width:'100%', padding:'9px 11px', borderRadius:8, border:"1px solid "+C.border, fontSize:13, fontFamily:F, boxSizing:'border-box', background:C.white, color:C.text };
const lbl = { fontSize:11, fontWeight:700, color:C.textMid, marginBottom:4, display:'block', textTransform:'uppercase', letterSpacing:.3 };
const btnP = { background:C.purple, border:"1px solid "+C.purple, borderRadius:8, color:'#fff', padding:'7px 13px', fontSize:12, cursor:'pointer', fontFamily:F, fontWeight:700 };
const btnS = { background:C.purpleLight, border:"1px solid "+C.purple, borderRadius:8, color:C.purple, padding:'7px 13px', fontSize:12, cursor:'pointer', fontFamily:F, fontWeight:700 };

const fmtData = d => d ? new Date(d).toLocaleDateString('pt-PT',{day:'2-digit',month:'2-digit',year:'numeric'}) : '—';
const mesAtual = () => new Date().toISOString().slice(0,7);
const RESPONSAVEIS = ['Francisco Araújo','Pedro Vilela','Cátia Tomás','Tânia Cunha','Tiago Santos','Patrícia Silva','Sara Batista','Andreia Croca'];
const fmtEur = v => (Number(v)||0).toLocaleString('pt-PT',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';

export default function MarketingPage({ perms, userEmail, voltar }){
  const [tab, setTab] = useState('leads'); // leads | campanhas
  const [leads, setLeads] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [mktProjetos, setMktProjetos] = useState([]);
  const [draftProj, setDraftProj] = useState(null);
  const [projAberto, setProjAberto] = useState(null);
  const [mktFases, setMktFases] = useState([]);
  const [draftFase, setDraftFase] = useState(null);
  const [mktTarefas, setMktTarefas] = useState([]);
  const [draftTarefa, setDraftTarefa] = useState(null);
  const [subView, setSubView] = useState('fases'); // dentro de um projeto: fases | financeiro
  const [mktMovs, setMktMovs] = useState([]);
  const [mktFaturas, setMktFaturas] = useState([]);
  const [editFat, setEditFat] = useState(null);
  const [fMov, setFMov] = useState({ tipo:'', rubrica:'', parceiro:'' });   // filtros da lista de movimentos   // {id, cliente, tipo_receita} — corrigir parceiro/rubrica de uma fatura do evento   // faturas ligadas a este evento (entradas, patrocínios, fees)
  const [rubricas, setRubricas] = useState([]);
  const [centros, setCentros] = useState([]);       // centros de custo do projeto aberto
  const [draftCentro, setDraftCentro] = useState(null);
  const [draftMov, setDraftMov] = useState(null);
  const [novaRubrica, setNovaRubrica] = useState('');
  const [subProj, setSubProj] = useState('fases'); // fases | resumo
  const [filtroResp, setFiltroResp] = useState('todas'); // todas | Francisco Araújo | Pedro Vilela
  const [mostrarFeitas, setMostrarFeitas] = useState(false);
  const [resumoTarefas, setResumoTarefas] = useState([]);
  const [orcamentos, setOrcamentos] = useState([]);
  const [vendas, setVendas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroMes, setFiltroMes] = useState(mesAtual());
  const [draftLead, setDraftLead] = useState(null);
  const [draftCamp, setDraftCamp] = useState(null);

  useEffect(()=>{ load(); },[]);
  const load = async () => {
    setLoading(true);
    const [{ data:lds }, { data:cps }, { data:orcs }, { data:vnds }] = await Promise.all([
      supabase.from('leads').select('*').order('data',{ascending:false}).limit(3000),
      supabase.from('campanhas').select('*').order('data_lancamento',{ascending:false}).limit(500),
      supabase.from('orcamentos').select('id,numero,cliente,estado,lead_id').eq('active',true).limit(3000),
      supabase.from('vendas').select('orcamento_id,valor').limit(5000),
    ]);
    if(lds) setLeads(lds);
    if(cps) setCampanhas(cps);
    const { data: mprojs } = await supabase.from('marketing_projetos').select('*').eq('ativo',true).order('created_at',{ascending:false});
    if(mprojs) setMktProjetos(mprojs);
    if(orcs) setOrcamentos(orcs);
    if(vnds) setVendas(vnds);
    setLoading(false);
  };

  // mapa lead_id -> orçamento (para saber quais converteram)
  const orcPorLead = useMemo(()=>{
    const m = {};
    orcamentos.forEach(o=>{ if(o.lead_id) (m[o.lead_id]=m[o.lead_id]||[]).push(o); });
    return m;
  }, [orcamentos]);

  // mapa lead_id -> valor gerado (soma dos orçamentos ganhos dessa lead)
  const valorPorLead = useMemo(()=>{
    const vpo = {}; vendas.forEach(v=>{ vpo[v.orcamento_id] = Number(v.valor)||0; });
    const m = {};
    orcamentos.forEach(o=>{ if(o.lead_id && o.estado==='ganho'){ m[o.lead_id] = (m[o.lead_id]||0) + (vpo[o.id]||0); } });
    return m;
  }, [orcamentos, vendas]);

  // leads do mês filtrado
  const leadsMes = useMemo(()=> leads.filter(l => (l.data||'').slice(0,7) === filtroMes), [leads, filtroMes]);

  // resumo do mês
  const resumo = useMemo(()=>{
    const total = leadsMes.length;
    let comOrc=0, ganhas=0;
    leadsMes.forEach(l=>{
      const orcs = orcPorLead[l.id]||[];
      if(orcs.length) comOrc++;
      if(orcs.some(o=>o.estado==='ganho')) ganhas++;
    });
    const taxa = total? Math.round(ganhas/total*100) : 0;
    return { total, comOrc, ganhas, taxa };
  }, [leadsMes, orcPorLead]);

  // CAC & funil (por campanha do mês + total)
  const cacData = useMemo(()=>{
    const campMes = campanhas.filter(cp => !cp.data_lancamento || (cp.data_lancamento||'').slice(0,7) === filtroMes || leads.some(l=>l.campanha_id===cp.id && (l.data||'').slice(0,7)===filtroMes));
    const linhas = campMes.map(cp=>{
      const lds = leadsMes.filter(l=>l.campanha_id===cp.id);
      const contratos = lds.filter(l=>(orcPorLead[l.id]||[]).some(o=>o.estado==='ganho')).length;
      const inv = Number(cp.investimento)||0;
      const clk = Number(cp.cliques)||0;
      return { id:cp.id, nome:cp.nome, cliques:clk, leads:lds.length, contratos,
        investimento:inv, cac: contratos>0 ? inv/contratos : null,
        clkLead: clk>0 ? Math.round(lds.length/clk*100) : null,
        leadCont: lds.length>0 ? Math.round(contratos/lds.length*100) : null };
    });
    const tot = linhas.reduce((a,r)=>({ cliques:a.cliques+r.cliques, leads:a.leads+r.leads,
      contratos:a.contratos+r.contratos, investimento:a.investimento+r.investimento }),
      { cliques:0, leads:0, contratos:0, investimento:0 });
    tot.cac = tot.contratos>0 ? tot.investimento/tot.contratos : null;
    tot.clkLead = tot.cliques>0 ? Math.round(tot.leads/tot.cliques*100) : null;
    tot.leadCont = tot.leads>0 ? Math.round(tot.contratos/tot.leads*100) : null;
    return { linhas, tot };
  }, [campanhas, leadsMes, orcPorLead, filtroMes, leads]);

  // meses disponíveis
  const meses = useMemo(()=>{
    const s = new Set(leads.map(l=>(l.data||'').slice(0,7)).filter(Boolean));
    s.add(mesAtual());
    return [...s].sort().reverse();
  }, [leads]);

  // ---- guardar lead ----
  const salvarLead = async () => {
    const d = draftLead;
    if(!d.empresa && !d.contacto){ alert('Preenche pelo menos a empresa ou o contacto.'); return; }
    if(d.estado==='perdida' && !(d.motivo_perda||'').trim()){ alert('Para marcar a lead como perdida tens de escrever o motivo da perda.'); return; }
    const payload = { data:d.data||new Date().toISOString().slice(0,10), empresa:d.empresa||null, contacto:d.contacto||null,
      pagina:d.pagina||null, origem:d.origem||null, campanha_id:d.campanha_id||null, estado:d.estado||'nova', notas:d.notas||null,
      motivo_perda: d.estado==='perdida' ? (d.motivo_perda||'').trim() : null };
    if(d.id) await supabase.from('leads').update(payload).eq('id',d.id);
    else await supabase.from('leads').insert(payload);
    setDraftLead(null); await load();
  };
  const apagarLead = async (id) => { if(!window.confirm('Apagar esta lead?')) return; await supabase.from('leads').delete().eq('id',id); await load(); };

  // ---- guardar campanha ----
  const salvarCamp = async () => {
    const d = draftCamp;
    if(!d.nome){ alert('A campanha precisa de um nome.'); return; }
    const payload = { nome:d.nome, data_lancamento:d.data_lancamento||null, canal:d.canal||null, url:d.url||null,
      area:d.area||null, cliques:Number(d.cliques)||0, investimento:Number(d.investimento)||0, ativa:d.ativa!==false, notas:d.notas||null };
    if(d.id) await supabase.from('campanhas').update(payload).eq('id',d.id);
    else await supabase.from('campanhas').insert(payload);
    setDraftCamp(null); await load();
  };
  const apagarCamp = async (id) => { if(!window.confirm('Apagar esta campanha?')) return; await supabase.from('campanhas').delete().eq('id',id); await load(); };

  // ---- guardar projeto de marketing ----
  const salvarProj = async () => {
    const d = draftProj;
    if(!d.nome){ alert('O projeto precisa de um nome.'); return; }
    const orc = (d.orcamento===''||d.orcamento==null) ? null : Number(String(d.orcamento).replace(',','.'));
    const payload = { nome:d.nome, responsavel:d.responsavel||null, estado:d.estado||'Ativo', descricao:d.descricao||null, prazo_termino:d.prazo_termino||null, orcamento:orc, usa_centros_custo: !!d.usa_centros_custo,
      ...(d.faturas_regra !== undefined ? { faturas_regra: (d.faturas_regra||'').trim() || null } : {}) };
    if(d.id){
      await supabase.from('marketing_projetos').update(payload).eq('id',d.id);
      if(projAberto && projAberto.id===d.id) setProjAberto({ ...projAberto, ...payload });
    }
    else await supabase.from('marketing_projetos').insert(payload);
    setDraftProj(null); await load();
  };
  const apagarProj = async (id) => { if(!window.confirm('Arquivar este projeto?')) return; await supabase.from('marketing_projetos').update({ativo:false}).eq('id',id); await load(); };

  // ---- fases de um projeto de marketing ----
  const abrirProjeto = async (proj) => {
    setProjAberto(proj);
    setSubView('fases');
    const { data } = await supabase.from('marketing_fases').select('*').eq('projeto_id',proj.id).order('ordem',{ascending:true}).order('created_at',{ascending:true});
    setMktFases(data||[]);
    carregarTarefas(proj.id);
    carregarFinanceiro(proj.id);
  };
  const recarregarFases = async () => {
    if(!projAberto) return;
    const { data } = await supabase.from('marketing_fases').select('*').eq('projeto_id',projAberto.id).order('ordem',{ascending:true}).order('created_at',{ascending:true});
    setMktFases(data||[]);
  };
  const carregarTarefas = async (projId) => {
    const { data } = await supabase.from('marketing_tarefas').select('*').eq('projeto_id',projId).order('created_at',{ascending:true});
    setMktTarefas(data||[]);
  };
  const carregarResumo = async () => {
    const { data } = await supabase.from('marketing_tarefas').select('*').order('data_lembrete',{ascending:true,nullsFirst:false});
    setResumoTarefas(data||[]);
  };
  const salvarTarefa = async () => {
    const d = draftTarefa;
    if(!d.texto){ alert('A tarefa precisa de um texto.'); return; }
    const payload = { fase_id:d.fase_id, projeto_id:projAberto.id, texto:d.texto, data_lembrete:d.data_lembrete||null, responsavel_nome:d.responsavel_nome||null, autor_email:userEmail||null, autor_nome:userEmail||null };
    if(d.id) await supabase.from('marketing_tarefas').update({ texto:d.texto, data_lembrete:d.data_lembrete||null, responsavel_nome:d.responsavel_nome||null }).eq('id',d.id);
    else await supabase.from('marketing_tarefas').insert(payload);
    setDraftTarefa(null); await carregarTarefas(projAberto.id);
  };
  const toggleTarefa = async (t) => {
    const nova = !t.feita;
    await supabase.from('marketing_tarefas').update({ feita:nova, feita_em: nova?new Date().toISOString():null }).eq('id',t.id);
    await carregarTarefas(projAberto.id);
  };
  const apagarTarefa = async (id) => { if(!window.confirm('Apagar esta tarefa?')) return; await supabase.from('marketing_tarefas').delete().eq('id',id); await carregarTarefas(projAberto.id); };
  const salvarFase = async () => {
    const d = draftFase;
    if(!d.nome){ alert('A fase precisa de um nome.'); return; }
    const payload = { projeto_id:projAberto.id, nome:d.nome, ordem:Number(d.ordem)||0, estado:d.estado||'Por iniciar', notas:d.notas||null, prazo:d.prazo||null, responsavel_nome:d.responsavel_nome||null };
    if(d.id) await supabase.from('marketing_fases').update(payload).eq('id',d.id);
    else await supabase.from('marketing_fases').insert(payload);
    setDraftFase(null); await recarregarFases();
  };
  const apagarFase = async (id) => { if(!window.confirm('Apagar esta fase?')) return; await supabase.from('marketing_fases').delete().eq('id',id); await recarregarFases(); };

  // ---- financeiro do projeto de marketing ----
  const carregarFinanceiro = async (projId) => {
    const [{ data:movs }, { data:rubs }, { data:ccs }] = await Promise.all([
      supabase.from('marketing_movimentos').select('*').eq('projeto_id',projId).order('data',{ascending:false}).order('created_at',{ascending:false}),
      supabase.from('marketing_rubricas').select('*').order('nome',{ascending:true}),
      supabase.from('marketing_centros_custo').select('*').eq('projeto_id',projId).order('ordem'),
    ]);
    setMktMovs(movs||[]);
    let fatsEv = [];
    try { const { data: fts, error: eF } = await supabase.from('faturas').select('id,numero,cliente,valor,valor_liquido,nc_valor,estado,data_emissao,data_pagamento,tipo_receita,nota').eq('marketing_projeto_id', projId).neq('estado','Anulada').order('data_emissao',{ascending:false});
      fatsEv = eF ? [] : (fts||[]); } catch (e) { fatsEv = []; }
    setMktFaturas(fatsEv);
    // receita prevista ↔ fatura: mesmo cliente (nome) e mesmo valor (com ou sem IVA, ±1 €)
    const nk = (t) => String(t||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\b(s\.?a\.?|lda\.?|unipessoal)\b/g,' ').replace(/[^a-z0-9]+/g,'');
    const ligadas = new Set((movs||[]).filter(m=>m.fatura_id!=null).map(m=>String(m.fatura_id)));
    const novasLig = [];
    (movs||[]).filter(m => m.tipo==='receita' && m.fatura_id==null && m.parceiro).forEach(m => {
      const a = nk(m.parceiro), v = Number(m.valor)||0;
      const f = fatsEv.find(x => !ligadas.has(String(x.id)) && a.length>=3 && (nk(x.cliente).includes(a) || a.includes(nk(x.cliente)))
        && (Math.abs(Number(x.valor_liquido!=null?x.valor_liquido:x.valor) - v) <= 1 || Math.abs(Number(x.valor) - v) <= 1));
      if (f) { ligadas.add(String(f.id)); novasLig.push({ id:m.id, fatura_id:f.id }); m.fatura_id = f.id; }
    });
    // uma fatura com várias linhas: liga todas as receitas previstas desse cliente cuja soma dá o valor da fatura
    fatsEv.filter(f => !ligadas.has(String(f.id))).forEach(f => {
      const c = nk(f.cliente); if (c.length < 3) return;
      const doCli = (movs||[]).filter(m => m.tipo==='receita' && m.fatura_id==null && m.parceiro && (nk(m.parceiro).includes(c) || c.includes(nk(m.parceiro))));
      if (doCli.length < 2) return;
      const tot = doCli.reduce((a,m)=>a+(Number(m.valor)||0),0);
      if (Math.abs(Number(f.valor_liquido!=null?f.valor_liquido:f.valor) - tot) <= 1 || Math.abs(Number(f.valor) - tot) <= 1) {
        ligadas.add(String(f.id)); doCli.forEach(m => { m.fatura_id = f.id; novasLig.push({ id:m.id, fatura_id:f.id }); });
      }
    });
    for (const l of novasLig) { try { await supabase.from('marketing_movimentos').update({ fatura_id:l.fatura_id }).eq('id', l.id); } catch (e) { /* coluna ainda não criada */ } }
    if (novasLig.length) setMktMovs([...(movs||[])]);
    setRubricas(rubs||[]);
    setCentros(ccs||[]);
  };
  const salvarMov = async () => {
    const d = draftMov;
    const valor = Number(String(d.valor==null?'':d.valor).replace(',','.'));
    if(!valor || valor<=0){ alert('Indica o valor (maior que zero).'); return; }
    let rubrica = d.tipo==='despesa' ? (d.rubrica||null) : (d.rubrica||'Bilheteira');
    if(d.tipo==='despesa' && d.rubrica==='__nova__'){
      const nome = (novaRubrica||'').trim();
      if(!nome){ alert('Escreve o nome da nova rubrica.'); return; }
      await supabase.from('marketing_rubricas').upsert({ nome }, { onConflict:'nome', ignoreDuplicates:true });
      rubrica = nome;
    }
    if(d.tipo==='despesa' && !rubrica){ alert('Escolhe a rubrica da despesa.'); return; }
    if(d.tipo==='receita' && !(d.parceiro||'').trim()){ alert('Indica o parceiro da receita.'); return; }
    const payload = { projeto_id:projAberto.id, tipo:d.tipo, rubrica,
      parceiro: (d.parceiro||'').trim() || null,
      descricao:d.descricao||null, valor, data:d.data||null,
      centro_custo_id: d.tipo==='despesa' ? (d.centro_custo_id||null) : null,
      estado: d.estado==='previsto' ? 'previsto' : 'realizado',
      autor_email:userEmail||null, autor_nome:userEmail||null };
    if(d.id) await supabase.from('marketing_movimentos').update(payload).eq('id',d.id);
    else await supabase.from('marketing_movimentos').insert(payload);
    setDraftMov(null); setNovaRubrica('');
    await carregarFinanceiro(projAberto.id);
  };
  const salvarCentro = async () => {
    const d = draftCentro;
    if(!d.nome || !d.nome.trim()){ alert('Dá um nome ao centro de custo.'); return; }
    const payload = {
      projeto_id: d.projeto_id || projAberto.id,
      nome: d.nome.trim(),
      orcamento: (d.orcamento===''||d.orcamento==null) ? null : Number(String(d.orcamento).replace(',','.')),
      ordem: d.ordem ?? centros.length,
    };
    const { error } = d.id
      ? await supabase.from('marketing_centros_custo').update(payload).eq('id', d.id)
      : await supabase.from('marketing_centros_custo').insert(payload);
    if(error){ alert('Não consegui guardar: '+error.message); return; }
    setDraftCentro(null);
    await carregarFinanceiro(projAberto.id);
  };

  const apagarCentro = async () => {
    if(!draftCentro?.id) return;
    const gastos = mktMovs.filter(m=>m.centro_custo_id===draftCentro.id).length;
    const msg = gastos
      ? `Apagar "${draftCentro.nome}"? As ${gastos} despesas imputadas ficam sem centro — não se perdem.`
      : `Apagar "${draftCentro.nome}"?`;
    if(!window.confirm(msg)) return;
    await supabase.from('marketing_centros_custo').delete().eq('id', draftCentro.id);
    setDraftCentro(null);
    await carregarFinanceiro(projAberto.id);
  };

  const marcarRealizado = async (m) => {
    await supabase.from('marketing_movimentos').update({ estado:'realizado', data: m.data || new Date().toISOString().slice(0,10) }).eq('id',m.id);
    await carregarFinanceiro(projAberto.id);
  };
  const apagarMov = async (id) => { if(!window.confirm('Apagar este movimento?')) return; await supabase.from('marketing_movimentos').delete().eq('id',id); await carregarFinanceiro(projAberto.id); };

  const campNome = id => campanhas.find(c=>c.id===id)?.nome || '—';

  if(loading) return <div style={{ padding:40, fontFamily:F, color:C.textMid }}>A carregar…</div>;

  return (
    <div style={{ fontFamily:F, color:C.text, maxWidth:1180, margin:'0 auto', padding:'0 24px', boxSizing:'border-box' }}>
      {/* Cabeçalho */}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:14, flexWrap:'wrap' }}>
        <button onClick={voltar} style={btnS}>← Comercial</button>
        <h1 style={{ fontSize:18, fontWeight:800, margin:0, color:C.purple }}>Marketing</h1>
        <div style={{ marginLeft:'auto', display:'flex', gap:8, alignItems:'center' }}>
          <label style={{ fontSize:12, color:C.textMid, fontWeight:700 }}>Mês</label>
          <select style={{ ...inp, width:'auto' }} value={filtroMes} onChange={e=>setFiltroMes(e.target.value)}>
            {meses.map(m=><option key={m} value={m}>{m}</option>)}
          </select>
        </div>
      </div>

      {/* Cards de resumo */}
      <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
        <Card label="Leads no mês" valor={resumo.total} cor={C.purple} />
        <Card label="Viraram orçamento" valor={resumo.comOrc} cor={C.blue} />
        <Card label="Ganhas" valor={resumo.ganhas} cor={C.green} />
        <Card label="Taxa de conversão" valor={resumo.taxa+'%'} cor={C.pink} />
      </div>

      {/* Separador Leads | Campanhas */}
      <div style={{ display:'flex', gap:8, marginBottom:12, borderBottom:"1px solid "+C.border, paddingBottom:10 }}>
        <button onClick={()=>setTab('leads')} style={tab==='leads'?btnP:btnS}>Leads</button>
        <button onClick={()=>setTab('campanhas')} style={tab==='campanhas'?btnP:btnS}>Campanhas</button>
        <button onClick={()=>setTab('cac')} style={tab==='cac'?btnP:btnS}>CAC & Funil</button>
        <button onClick={()=>setTab('projetos')} style={tab==='projetos'?btnP:btnS}>Projetos</button>
        <div style={{ marginLeft:'auto' }}>
          {tab==='cac' ? null : tab==='projetos'
            ? <button onClick={()=>setDraftProj({ estado:'Ativo' })} style={btnP}>+ Novo projeto</button>
            : tab==='leads'
            ? <button onClick={()=>setDraftLead({ data:new Date().toISOString().slice(0,10), estado:'nova' })} style={btnP}>+ Nova lead</button>
            : <button onClick={()=>setDraftCamp({ ativa:true, data_lancamento:new Date().toISOString().slice(0,10) })} style={btnP}>+ Nova campanha</button>}
        </div>
      </div>

      {/* LISTA DE LEADS */}
      {tab==='leads' && (
        <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, overflow:'hidden' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
            <thead><tr style={{ background:C.bg, textAlign:'left' }}>
              {['Data','Empresa','Página','Origem','Campanha','Estado','Orçamento',''].map(h=>
                <th key={h} style={{ padding:'8px 12px', color:C.textMid, fontWeight:700, fontSize:10, textTransform:'uppercase' }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {leadsMes.length===0 && <tr><td colSpan={8} style={{ padding:24, textAlign:'center', color:C.textLight }}>Sem leads neste mês. Adiciona a primeira com "+ Nova lead".</td></tr>}
              {leadsMes.map(l=>{
                const orcs = orcPorLead[l.id]||[];
                const est = ESTADOS_LEAD[l.estado]||ESTADOS_LEAD.nova;
                const ganhou = orcs.some(o=>o.estado==='ganho');
                return (
                  <tr key={l.id} style={{ borderTop:"1px solid "+C.border }}>
                    <td style={{ padding:'7px 12px', color:C.textMid, whiteSpace:'nowrap' }}>{fmtData(l.data)}</td>
                    <td style={{ padding:'7px 12px', fontWeight:600 }}>{l.empresa||'—'}</td>
                    <td style={{ padding:'7px 12px', color:C.textMid, maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={l.pagina}>{l.pagina||'—'}</td>
                    <td style={{ padding:'7px 12px', color:C.textMid }}>{l.origem||'—'}</td>
                    <td style={{ padding:'7px 12px', color:C.textMid }}>{l.campanha_id?campNome(l.campanha_id):'—'}</td>
                    <td style={{ padding:'7px 12px' }}><span title={l.estado==='perdida' && l.motivo_perda ? 'Motivo: '+l.motivo_perda : undefined} style={{ background:est.bg, color:est.color, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700, cursor:l.estado==='perdida'&&l.motivo_perda?'help':'default' }}>{est.label}</span></td>
                    <td style={{ padding:'7px 12px' }}>{orcs.length? <span style={{ color:ganhou?C.green:C.purple, fontWeight:700 }}>{orcs.map(o=>o.numero).join(', ')}{ganhou?' ✓':''}</span> : <span style={{ color:C.textLight }}>—</span>}</td>
                    <td style={{ padding:'7px 12px', textAlign:'right', whiteSpace:'nowrap' }}>
                      <button onClick={()=>setDraftLead({...l})} style={{ ...btnS, padding:'5px 10px', marginRight:6 }}>✏️</button>
                      <button onClick={()=>apagarLead(l.id)} style={{ background:C.redLight, border:"1px solid "+C.red, borderRadius:8, color:C.red, padding:'5px 10px', cursor:'pointer' }}>🗑️</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* LISTA DE CAMPANHAS */}
      {tab==='campanhas' && (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(300px,1fr))', gap:14 }}>
          {campanhas.length===0 && <div style={{ padding:24, color:C.textLight }}>Sem campanhas. Adiciona a primeira com "+ Nova campanha".</div>}
          {campanhas.map(cp=>{
            const leadsCamp = leads.filter(l=>l.campanha_id===cp.id);
            const convertidas = leadsCamp.filter(l=>(orcPorLead[l.id]||[]).some(o=>o.estado==='ganho')).length;
            const taxa = leadsCamp.length? Math.round(convertidas/leadsCamp.length*100):0;
            return (
              <div key={cp.id} style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:16 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:8 }}>
                  <div style={{ fontWeight:800, fontSize:15, color:C.purple }}>{cp.nome}</div>
                  <div style={{ display:'flex', gap:4 }}>
                    <button onClick={()=>setDraftCamp({...cp})} style={{ ...btnS, padding:'4px 8px' }}>✏️</button>
                    <button onClick={()=>apagarCamp(cp.id)} style={{ background:C.redLight, border:"1px solid "+C.red, borderRadius:8, color:C.red, padding:'4px 8px', cursor:'pointer' }}>🗑️</button>
                  </div>
                </div>
                {cp.area && <div style={{ display:'inline-block', background:C.purpleLight, color:C.purple, padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:700, marginBottom:8 }}>{cp.area}</div>}
                <div style={{ fontSize:12, color:C.textMid, marginBottom:10 }}>
                  {cp.canal||'—'} · lançada {fmtData(cp.data_lancamento)}
                  {cp.url && <div style={{ marginTop:2, color:C.blue, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={cp.url}>{cp.url}</div>}
                </div>
                <div style={{ display:'flex', gap:12, borderTop:"1px solid "+C.border, paddingTop:10 }}>
                  <Mini label="Cliques" v={cp.cliques||0} />
                  <Mini label="Leads" v={leadsCamp.length} />
                  <Mini label="Ganhas" v={convertidas} cor={C.green} />
                  <Mini label="Conv." v={taxa+'%'} cor={C.pink} />
                </div>
                <div style={{ display:'flex', gap:12, borderTop:"1px solid "+C.border, paddingTop:10, marginTop:10 }}>
                  <Mini label="Valor gerado" v={(leadsCamp.reduce((a,l)=>a+(valorPorLead[l.id]||0),0)).toLocaleString('pt-PT')+' EUR'} cor={C.purpleDark} />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ABA PROJETOS - VISTA DE UM PROJETO ABERTO (FASES) */}
      {tab==='projetos' && projAberto && (
        <div>
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16 }}>
            <button onClick={()=>{ setProjAberto(null); setMktFases([]); setMktMovs([]); }} style={btnS}>← Voltar</button>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:18, fontWeight:800, color:C.text }}>{projAberto.nome}</div>
              <div style={{ fontSize:12, color:C.textLight }}>{projAberto.responsavel?`${projAberto.responsavel} · `:''}{projAberto.estado||'Ativo'}</div>
            </div>
            {subView==='fases'
              ? <button onClick={()=>setDraftFase({ estado:'Por iniciar', ordem:mktFases.length })} style={btnP}>+ Nova fase</button>
              : <button onClick={()=>setDraftMov({ tipo:'despesa', data:new Date().toISOString().slice(0,10) })} style={btnP}>+ Movimento</button>}
          </div>
          <div style={{ display:'flex', gap:8, marginBottom:14 }}>
            <button onClick={()=>setSubView('fases')} style={subView==='fases'?btnP:btnS}>Fases e tarefas</button>
            <button onClick={()=>setSubView('financeiro')} style={subView==='financeiro'?btnP:btnS}>💰 Financeiro</button>
          </div>
          {subView==='fases' && (
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {mktFases.length===0 && <div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:"1px solid "+C.border }}>Sem fases. Clica em "+ Nova fase" para criar.</div>}
            {mktFases.map(fa=>{
              const cor = fa.estado==='Feito'?C.green:fa.estado==='Em curso'?C.amber:C.textLight;
              return (
              <div key={fa.id} style={{ background:C.white, border:"1px solid "+C.border, borderRadius:10, padding:'14px 18px' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <span style={{ fontSize:15, fontWeight:700, color:C.text }}>{fa.nome}</span>
                      <span style={{ fontSize:10, fontWeight:700, color:cor, background:C.bg, borderRadius:6, padding:'2px 8px', textTransform:'uppercase' }}>{fa.estado||'Por iniciar'}</span>
                      {fa.responsavel_nome && <span style={{ fontSize:10, color:C.purple, background:C.purpleLight, borderRadius:5, padding:'1px 6px', fontWeight:600 }}>{fa.responsavel_nome}</span>}
                      {fa.prazo && <span style={{ fontSize:11, color:C.textLight }}>até {new Date(fa.prazo).toLocaleDateString('pt-PT')}</span>}
                    </div>
                    {fa.notas && <div style={{ fontSize:12, color:C.textMid, marginTop:4 }}>{fa.notas}</div>}
                  </div>
                  <button onClick={()=>setDraftFase(fa)} style={btnS}>Editar</button>
                  <button onClick={()=>apagarFase(fa.id)} style={{ ...btnS, color:'#C0392B' }}>Apagar</button>
                </div>
                <div style={{ marginTop:12, paddingTop:12, borderTop:"1px dashed "+C.border }}>
                  {mktTarefas.filter(t=>t.fase_id===fa.id).map(t=>{
                    const hoje = new Date().toISOString().slice(0,10);
                    const atrasada = t.data_lembrete && !t.feita && t.data_lembrete < hoje;
                    return (
                    <div key={t.id} style={{ display:'flex', alignItems:'center', gap:9, padding:'5px 0' }}>
                      <input type="checkbox" checked={t.feita} onChange={()=>toggleTarefa(t)} style={{ cursor:'pointer', width:15, height:15 }}/>
                      <span style={{ flex:1, fontSize:13, color:t.feita?C.textLight:C.text, textDecoration:t.feita?'line-through':'none' }}>{t.texto}</span>
                      {t.responsavel_nome && <span style={{ fontSize:10, color:C.purple, background:C.purpleLight, borderRadius:5, padding:'1px 6px', fontWeight:600 }}>{t.responsavel_nome}</span>}
                      {t.data_lembrete && <span style={{ fontSize:11, fontWeight:600, color: t.feita?C.textLight : atrasada?'#C0392B':C.textLight }}>{new Date(t.data_lembrete+'T00:00:00').toLocaleDateString('pt-PT')}</span>}
                      <button onClick={()=>apagarTarefa(t.id)} style={{ background:'none', border:'none', color:C.textLight, cursor:'pointer', fontSize:14 }}>×</button>
                    </div>
                    );
                  })}
                  <button onClick={()=>setDraftTarefa({ fase_id:fa.id })} style={{ ...btnS, marginTop:6, fontSize:11, padding:'5px 10px' }}>+ Tarefa</button>
                </div>
              </div>
              );
            })}
          </div>
          )}

          {subView==='financeiro' && (()=>{
            const soma = arr => arr.reduce((a,m)=>a+(Number(m.valor)||0),0);
            const desps = mktMovs.filter(m=>m.tipo==='despesa');
            const recs  = mktMovs.filter(m=>m.tipo==='receita');
            const dReal = soma(desps.filter(m=>m.estado!=='previsto'));
            const dPrev = soma(desps.filter(m=>m.estado==='previsto'));
            // receitas: manuais sem fatura (realizado/previsto) + faturas do evento (pagas = recebido; por pagar = por receber)
            const liqF0 = (f) => { const b = Number(f.valor)||0, l = Number(f.valor_liquido!=null?f.valor_liquido:f.valor)||0, nc = Number(f.nc_valor)||0; return b ? Math.max(0, l - nc*(l/b)) : l; };
            const recsSemFat = recs.filter(m=>m.fatura_id==null);
            const rReal = soma(recsSemFat.filter(m=>m.estado!=='previsto')) + mktFaturas.filter(f=>f.estado==='Paga').reduce((a,f)=>a+liqF0(f),0);
            const rPrev = soma(recsSemFat.filter(m=>m.estado==='previsto')) + mktFaturas.filter(f=>f.estado!=='Paga').reduce((a,f)=>a+liqF0(f),0);
            const totD = dReal + dPrev;
            // faturas do evento: valor sem IVA, já descontadas as notas de crédito
            const liqF = (f) => { const b = Number(f.valor)||0, l = Number(f.valor_liquido!=null?f.valor_liquido:f.valor)||0, nc = Number(f.nc_valor)||0; return b ? Math.max(0, l - nc*(l/b)) : l; };
            const fatTot = mktFaturas.reduce((a,f)=>a+liqF(f),0);
            const fatRec = mktFaturas.filter(f=>f.estado==='Paga').reduce((a,f)=>a+liqF(f),0);
            const porTipo = {}; mktFaturas.forEach(f=>{ const k=f.tipo_receita||'Serviço'; porTipo[k]=(porTipo[k]||0)+liqF(f); });
            const saldo = rReal - dReal;
            const orc = (projAberto.orcamento!=null && projAberto.orcamento!=='') ? Number(projAberto.orcamento) : null;
            const disp = orc!=null ? orc - totD : null;
            const pctGasto = (orc!=null && orc>0) ? Math.round(totD/orc*100) : null;
            return (
            <div>
              <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
                <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'11px 14px', flex:1, minWidth:150 }}>
                  <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>Orçamento (para jogar)</div>
                  <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:2 }}>
                    <span style={{ fontSize:22, fontWeight:800, color:C.purple }}>{orc!=null ? fmtEur(orc) : '—'}</span>
                    <button onClick={()=>setDraftProj({...projAberto})} title="Definir orçamento" style={{ ...btnS, padding:'3px 8px', fontSize:11 }}>✏️</button>
                  </div>
                </div>
                <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'11px 14px', flex:1, minWidth:130 }}>
                  <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>Despesas realizadas</div>
                  <div style={{ fontSize:22, fontWeight:800, color:C.red, marginTop:2 }}>{fmtEur(dReal)}</div>
                  {dPrev>0 && <div style={{ fontSize:11, fontWeight:700, color:C.amber, marginTop:2 }}>+ {fmtEur(dPrev)} previstas</div>}
                </div>
                <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'11px 14px', flex:1, minWidth:130 }}>
                  <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>Receitas recebidas</div>
                  <div style={{ fontSize:22, fontWeight:800, color:C.green, marginTop:2 }}>{fmtEur(rReal)}</div>
                  {rPrev>0 && <div style={{ fontSize:11, fontWeight:700, color:C.amber, marginTop:2 }}>+ {fmtEur(rPrev)} por receber (previstas ou faturadas)</div>}
                </div>
                {mktFaturas.length>0 && (
                  <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'11px 14px', flex:1, minWidth:170 }}>
                    <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>Faturado (s/ IVA)</div>
                    <div style={{ fontSize:22, fontWeight:800, color:C.green, marginTop:2 }}>{fmtEur(fatTot)}</div>
                    <div style={{ fontSize:11, color:C.textLight, marginTop:2 }}>{Object.entries(porTipo).map(([k,v])=>`${k} ${fmtEur(v)}`).join(' · ')}</div>
                    <div style={{ fontSize:11, fontWeight:700, color: fatRec < fatTot ? C.amber : C.green, marginTop:2 }}>{fmtEur(fatRec)} recebido</div>
                  </div>)}
                <Card label="Saldo realizado" valor={(saldo>=0?'+':'−')+fmtEur(Math.abs(saldo))} cor={saldo>=0?C.green:C.red} />
                <div style={{ background:C.white, borderRadius:12, border:"1px solid "+(disp!=null && disp<0 ? C.red : C.border), padding:'11px 14px', flex:1, minWidth:150 }}>
                  <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>Disponível do orçamento</div>
                  <div style={{ fontSize:22, fontWeight:800, color: disp==null?C.textLight : disp<0?C.red:C.green, marginTop:2 }}>{disp!=null ? (disp>=0?'':'−')+fmtEur(Math.abs(disp)) : '—'}</div>
                  {pctGasto!=null && <div style={{ fontSize:11, fontWeight:700, color: pctGasto>100?C.red : pctGasto>=80?C.amber : C.textLight, marginTop:2 }}>{pctGasto}% comprometido (realizado + previsto){pctGasto>100?' · acima!':''}</div>}
                </div>
              </div>

              {/* CENTROS DE CUSTO — só nos projetos que os usam */}
              {projAberto.usa_centros_custo && (()=>{
                const gastoDe = (cid) => soma(mktMovs.filter(m=>m.tipo==='despesa' && m.centro_custo_id===cid));
                const semCentro = mktMovs.filter(m=>m.tipo==='despesa' && !m.centro_custo_id);
                const somaCentros = centros.reduce((a,cc)=>a+(Number(cc.orcamento)||0),0);
                return (
                <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'14px 16px', marginBottom:14 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:10, flexWrap:'wrap', marginBottom:10 }}>
                    <div>
                      <span style={{ fontSize:13.5, fontWeight:800, color:C.purple }}>Centros de custo</span>
                      {orc!=null && (
                        <span style={{ fontSize:11.5, color: Math.abs(somaCentros-orc)>0.01 ? C.amber : C.textLight, marginLeft:8 }}>
                          {fmtEur(somaCentros)} distribuídos de {fmtEur(orc)}
                          {Math.abs(somaCentros-orc)>0.01 && (somaCentros>orc
                            ? ` · ${fmtEur(somaCentros-orc)} acima do orçamento do projeto`
                            : ` · faltam distribuir ${fmtEur(orc-somaCentros)}`)}
                        </span>
                      )}
                    </div>
                    <button onClick={()=>setDraftCentro({ projeto_id:projAberto.id, nome:'', orcamento:'' })}
                      style={{ ...btnS, fontSize:12 }}>+ Centro de custo</button>
                  </div>

                  {centros.length===0 ? (
                    <div style={{ fontSize:12.5, color:C.textLight, padding:'6px 0' }}>
                      Ainda sem centros definidos. Acrescenta o primeiro para poderes imputar as despesas.
                    </div>
                  ) : (
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(215px,1fr))', gap:10 }}>
                      {centros.map(cc=>{
                        const g = gastoDe(cc.id);
                        const o = Number(cc.orcamento)||0;
                        const pct = o>0 ? Math.round(g/o*100) : null;
                        const cor = pct==null ? C.textLight : pct>100 ? C.red : pct>=80 ? C.amber : C.green;
                        return (
                          <div key={cc.id} style={{ border:'1px solid '+(pct>100?C.red:C.border), borderRadius:10, padding:'11px 13px', background:C.bg }}>
                            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:6 }}>
                              <span style={{ fontSize:12.5, fontWeight:700 }}>{cc.nome}</span>
                              <button onClick={()=>setDraftCentro({...cc})} title="Editar"
                                style={{ background:'none', border:'none', cursor:'pointer', fontSize:11, color:C.textLight, padding:0 }}>✏️</button>
                            </div>
                            <div style={{ fontSize:17, fontWeight:800, color:cor, marginTop:3 }}>{fmtEur(g)}</div>
                            <div style={{ fontSize:11, color:C.textLight }}>
                              de {o>0 ? fmtEur(o) : '— sem orçamento'}{pct!=null && ` · ${pct}%`}
                            </div>
                            {o>0 && (
                              <div style={{ height:6, background:C.border, borderRadius:4, marginTop:6, overflow:'hidden' }}>
                                <div style={{ height:6, width:Math.min(100,pct||0)+'%', background:cor }}/>
                              </div>
                            )}
                            {o>0 && <div style={{ fontSize:11, color: g>o?C.red:C.textLight, marginTop:4 }}>
                              {g>o ? `${fmtEur(g-o)} acima` : `${fmtEur(o-g)} disponíveis`}</div>}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {semCentro.length>0 && (
                    <div style={{ marginTop:10, fontSize:11.5, color:'#8A6D00', background:'#FDF8E7', borderRadius:8, padding:'8px 11px' }}>
                      {semCentro.length} despesa(s) no valor de {fmtEur(soma(semCentro))} ainda sem centro de custo atribuído.
                    </div>
                  )}
                </div>
                );
              })()}

              {(() => {
                // valores de cada linha (movimentos e faturas do evento) para filtrar e somar
                const liqFx = (f) => { const b = Number(f.valor)||0, l = Number(f.valor_liquido!=null?f.valor_liquido:f.valor)||0, nc = Number(f.nc_valor)||0; return b ? Math.max(0, l - nc*(l/b)) : l; };
                const linhasTodas = [
                  ...mktMovs.map(m => ({ tipo:m.tipo, rubrica:m.rubrica || (m.tipo==='receita' ? 'Bilheteira' : '—'), parceiro:m.parceiro || '—', valor:Number(m.valor)||0 })),
                  ...mktFaturas.filter(f => !mktMovs.some(m => String(m.fatura_id) === String(f.id))).map(f => ({ tipo:'receita', rubrica:f.tipo_receita || 'Bilheteira', parceiro:f.cliente || '—', valor:liqFx(f) })),
                ];
                const opRub = [...new Set(linhasTodas.filter(l => !fMov.tipo || l.tipo===fMov.tipo).map(l => l.rubrica))].sort((a,b)=>a.localeCompare(b,'pt'));
                const opPar = [...new Set(linhasTodas.filter(l => (!fMov.tipo || l.tipo===fMov.tipo) && (!fMov.rubrica || l.rubrica===fMov.rubrica)).map(l => l.parceiro))].sort((a,b)=>a.localeCompare(b,'pt'));
                const vis = linhasTodas.filter(l => (!fMov.tipo || l.tipo===fMov.tipo) && (!fMov.rubrica || l.rubrica===fMov.rubrica) && (!fMov.parceiro || l.parceiro===fMov.parceiro));
                const ent = vis.filter(l=>l.tipo==='receita').reduce((a,l)=>a+l.valor,0), sai = vis.filter(l=>l.tipo==='despesa').reduce((a,l)=>a+l.valor,0);
                const sel = { ...inp, width:'auto', padding:'6px 9px', fontSize:12.5 };
                return (
                <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', marginBottom:8 }}>
                  <select style={sel} value={fMov.tipo} onChange={e=>setFMov({ tipo:e.target.value, rubrica:'', parceiro:'' })}><option value="">Entradas e saídas</option><option value="receita">Só entradas</option><option value="despesa">Só saídas</option></select>
                  <select style={sel} value={fMov.rubrica} onChange={e=>setFMov({ ...fMov, rubrica:e.target.value, parceiro:'' })}><option value="">Todas as rubricas</option>{opRub.map(r => <option key={r} value={r}>{r}</option>)}</select>
                  <select style={sel} value={fMov.parceiro} onChange={e=>setFMov({ ...fMov, parceiro:e.target.value })}><option value="">Todos os parceiros</option>{opPar.map(r => <option key={r} value={r}>{r}</option>)}</select>
                  {(fMov.tipo || fMov.rubrica || fMov.parceiro) && <button onClick={()=>setFMov({ tipo:'', rubrica:'', parceiro:'' })} style={{ ...btnS, padding:'5px 10px', fontSize:12 }}>limpar</button>}
                  <span style={{ flex:1 }}/>
                  <span style={{ fontSize:12.5, color:C.textMid }}>{vis.length} linha(s) · <b style={{ color:C.green }}>+{fmtEur(ent)}</b> · <b style={{ color:C.red }}>−{fmtEur(sai)}</b></span>
                </div>); })()}
              <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, overflow:'hidden' }}>
                <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                  <thead><tr style={{ background:C.bg, textAlign:'left' }}>
                    {['Data','Tipo','Estado','Rubrica','Parceiro','Descrição','Valor',''].map(h=>
                      <th key={h} style={{ padding:'8px 12px', color:C.textMid, fontWeight:700, fontSize:10, textTransform:'uppercase' }}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {mktMovs.length===0 && mktFaturas.length===0 && <tr><td colSpan={8} style={{ padding:24, textAlign:'center', color:C.textLight }}>Sem movimentos. Regista o primeiro com "+ Movimento".</td></tr>}
                    {/* faturas ligadas ao evento (vêm do Financeiro; editam-se lá) */}
                    {mktFaturas.filter(f => !mktMovs.some(m => String(m.fatura_id) === String(f.id)))
                      .filter(f => (!fMov.tipo || fMov.tipo==='receita') && (!fMov.rubrica || (f.tipo_receita||'Bilheteira')===fMov.rubrica) && (!fMov.parceiro || (f.cliente||'—')===fMov.parceiro)).map(f=>{
                      const paga = f.estado==='Paga';
                      return (
                      <tr key={'f'+f.id} style={{ borderTop:"1px solid "+C.border }}>
                        <td style={{ padding:'7px 12px', color:C.textMid, whiteSpace:'nowrap' }}>{fmtData(f.data_emissao)}</td>
                        <td style={{ padding:'7px 12px' }}><span style={{ background:C.greenLight, color:C.green, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700 }}>Receita · fatura</span></td>
                        <td style={{ padding:'7px 12px', whiteSpace:'nowrap' }}><span style={{ background:paga?C.greenLight:C.amberLight, color:paga?C.green:C.amber, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700 }}>{paga?'Recebida':'Faturada'}</span></td>
                        {editFat && editFat.id === f.id ? (<>
                          <td style={{ padding:'5px 8px' }}>
                            <select style={{ ...inp, padding:'5px 8px', width:'auto' }} value={editFat.tipo_receita} onChange={e=>setEditFat({ ...editFat, tipo_receita:e.target.value })}>
                              {['Bilheteira','Espaço empresa','Patrocínio','Fee','Serviço'].map(t => <option key={t} value={t}>{t}</option>)}
                            </select></td>
                          <td style={{ padding:'5px 8px' }}><input style={{ ...inp, padding:'5px 8px' }} value={editFat.cliente} onChange={e=>setEditFat({ ...editFat, cliente:e.target.value })}/></td>
                        </>) : (<>
                          <td style={{ padding:'7px 12px' }}>{f.tipo_receita||'Bilheteira'}</td>
                          <td style={{ padding:'7px 12px', fontWeight:600 }}>{f.cliente||'—'}</td>
                        </>)}
                        <td style={{ padding:'7px 12px', color:C.textMid }}>{f.numero}{f.nota?` · ${String(f.nota).slice(0,60)}`:''}</td>
                        <td style={{ padding:'7px 12px', fontWeight:800, color:C.green, whiteSpace:'nowrap' }}>+{fmtEur((() => { const b = Number(f.valor)||0, l = Number(f.valor_liquido!=null?f.valor_liquido:f.valor)||0, nc = Number(f.nc_valor)||0; return b ? Math.max(0, l - nc*(l/b)) : l; })())}</td>
                        <td style={{ padding:'7px 12px', textAlign:'right', whiteSpace:'nowrap' }}>
                          {editFat && editFat.id === f.id ? (<>
                            <button onClick={async()=>{ const { error } = await supabase.from('faturas').update({ cliente:(editFat.cliente||'').trim()||f.cliente, tipo_receita:editFat.tipo_receita }).eq('id', f.id); if(error){ alert('Não consegui gravar: '+error.message); return; } setEditFat(null); await carregarFinanceiro(projAberto.id); }} style={{ ...btnS, padding:'5px 10px', marginRight:6 }}>💾</button>
                            <button onClick={()=>setEditFat(null)} style={{ ...btnS, padding:'5px 10px' }}>✕</button>
                          </>) : (
                            <button title="Corrigir parceiro e tipo de receita (o resto edita-se no Financeiro → Faturas)" onClick={()=>setEditFat({ id:f.id, cliente:f.cliente||'', tipo_receita:f.tipo_receita||'Bilheteira' })} style={{ ...btnS, padding:'5px 10px' }}>✏️</button>)}
                        </td>
                      </tr>);
                    })}
                    {mktMovs.filter(m => (!fMov.tipo || m.tipo===fMov.tipo) && (!fMov.rubrica || (m.rubrica || (m.tipo==='receita' ? 'Bilheteira' : '—'))===fMov.rubrica) && (!fMov.parceiro || (m.parceiro||'—')===fMov.parceiro)).map(m=>{
                      const desp = m.tipo==='despesa';
                      const fatL = m.fatura_id!=null ? mktFaturas.find(f => String(f.id) === String(m.fatura_id)) : null;
                      const prev = fatL ? fatL.estado!=='Paga' : m.estado==='previsto';
                      return (
                      <tr key={m.id} style={{ borderTop:"1px solid "+C.border, opacity:prev?0.85:1 }}>
                        <td style={{ padding:'7px 12px', color:C.textMid, whiteSpace:'nowrap' }}>{fmtData(m.data)}</td>
                        <td style={{ padding:'7px 12px' }}><span style={{ background:desp?C.redLight:C.greenLight, color:desp?C.red:C.green, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700 }}>{desp?'Despesa':'Receita'}</span></td>
                        <td style={{ padding:'7px 12px', whiteSpace:'nowrap' }}>
                          <span style={{ background:prev?C.amberLight:C.bg, color:prev?C.amber:C.textMid, padding:'3px 9px', borderRadius:20, fontSize:11, fontWeight:700, border:prev?'1px dashed '+C.amber:'1px solid transparent' }}>{fatL ? (fatL.estado==='Paga' ? 'Recebida' : 'Faturada') : prev?'Previsto':'Realizado'}</span>
                          {prev && !fatL && <button onClick={()=>marcarRealizado(m)} title="Marcar como realizado" style={{ ...btnS, padding:'3px 8px', fontSize:11, marginLeft:6 }}>✓</button>}
                        </td>
                        <td style={{ padding:'7px 12px' }}>{m.rubrica || (desp ? '—' : 'Bilheteira')}</td>
                        <td style={{ padding:'7px 12px', fontWeight:600 }}>{m.parceiro||'—'}</td>
                        <td style={{ padding:'7px 12px', color:C.textMid }}>{m.descricao||'—'}{fatL ? ` · ${fatL.numero}` : (!desp && prev ? ' · por faturar' : '')}</td>
                        <td style={{ padding:'7px 12px', fontWeight:800, color:desp?C.red:C.green, whiteSpace:'nowrap' }}>{desp?'−':'+'}{fmtEur(m.valor)}</td>
                        <td style={{ padding:'7px 12px', textAlign:'right', whiteSpace:'nowrap' }}>
                          <button onClick={()=>{ setNovaRubrica(''); setDraftMov({...m}); }} style={{ ...btnS, padding:'5px 10px', marginRight:6 }}>✏️</button>
                          <button onClick={()=>apagarMov(m.id)} style={{ background:C.redLight, border:"1px solid "+C.red, borderRadius:8, color:C.red, padding:'5px 10px', cursor:'pointer' }}>🗑️</button>
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            );
          })()}
        </div>
      )}

      {/* SUB-NAV Projetos: Fases | Resumo */}
      {tab==='projetos' && !projAberto && (
        <div style={{ display:'flex', gap:8, marginBottom:14 }}>
          <button onClick={()=>setSubProj('fases')} style={subProj==='fases'?btnP:btnS}>Projetos</button>
          <button onClick={()=>{ setSubProj('resumo'); carregarResumo(); }} style={subProj==='resumo'?btnP:btnS}>📋 Resumo de tarefas</button>
        </div>
      )}

      {/* ABA PROJETOS - RESUMO DE TAREFAS */}
      {tab==='projetos' && !projAberto && subProj==='resumo' && (()=>{
        const hoje = new Date().toISOString().slice(0,10);
        const nomeProj = {}; mktProjetos.forEach(p=>{ nomeProj[p.id]=p.nome; });
        const filttar = resumoTarefas.filter(t=>{
          if(filtroResp==='todas') return true;
          return (t.responsavel_nome||'').includes(filtroResp);
        });
        const pendentes = filttar.filter(t=>!t.feita);
        const feitas = filttar.filter(t=>t.feita);
        // agrupar pendentes por projeto
        const porProj = {};
        pendentes.forEach(t=>{ const k=t.projeto_id||'sem'; if(!porProj[k])porProj[k]=[]; porProj[k].push(t); });
        const fbtn=(v,l)=>(<button onClick={()=>setFiltroResp(v)} style={filtroResp===v?btnP:btnS}>{l}</button>);
        return (
        <div>
          <div style={{ display:'flex', gap:8, marginBottom:14 }}>
            {fbtn('todas','Todas')}{RESPONSAVEIS.map(n=><React.Fragment key={n}>{fbtn(n, n.split(' ')[0])}</React.Fragment>)}
          </div>
          {pendentes.length===0 && <div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:"1px solid "+C.border }}>Sem tarefas pendentes. 🎉</div>}
          {Object.keys(porProj).map(pid=>(
            <div key={pid} style={{ marginBottom:16 }}>
              <div style={{ fontSize:13, fontWeight:800, color:C.purple, marginBottom:6 }}>{nomeProj[pid]||'(projeto arquivado)'}</div>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {porProj[pid].map(t=>{
                  const atrasada = t.data_lembrete && t.data_lembrete<hoje;
                  return (
                  <div key={t.id} style={{ display:'flex', alignItems:'center', gap:10, background:C.white, border:"1px solid "+(atrasada?'#F5C6C0':C.border), borderRadius:9, padding:'10px 14px' }}>
                    <input type="checkbox" checked={false} onChange={()=>toggleTarefa(t)} style={{ cursor:'pointer', width:15, height:15 }}/>
                    <span style={{ flex:1, fontSize:13, color:C.text }}>{t.texto}</span>
                    {t.responsavel_nome && <span style={{ fontSize:10, color:C.purple, background:C.purpleLight, borderRadius:5, padding:'1px 6px', fontWeight:600 }}>{t.responsavel_nome}</span>}
                    {t.data_lembrete && <span style={{ fontSize:11, fontWeight:600, color:atrasada?'#C0392B':C.textLight }}>{new Date(t.data_lembrete+'T00:00:00').toLocaleDateString('pt-PT')}{atrasada?' · atraso':''}</span>}
                  </div>
                  );
                })}
              </div>
            </div>
          ))}
          {feitas.length>0 && (
            <div style={{ marginTop:20 }}>
              <button onClick={()=>setMostrarFeitas(!mostrarFeitas)} style={{ ...btnS, width:'100%', textAlign:'left' }}>{mostrarFeitas?'▼':'▶'} Tarefas feitas ({feitas.length})</button>
              {mostrarFeitas && <div style={{ display:'flex', flexDirection:'column', gap:6, marginTop:8 }}>
                {feitas.map(t=>(
                  <div key={t.id} style={{ display:'flex', alignItems:'center', gap:10, background:C.bg, borderRadius:9, padding:'8px 14px' }}>
                    <input type="checkbox" checked={true} onChange={()=>toggleTarefa(t)} style={{ cursor:'pointer', width:15, height:15 }}/>
                    <span style={{ flex:1, fontSize:13, color:C.textLight, textDecoration:'line-through' }}>{t.texto}</span>
                    <span style={{ fontSize:11, color:C.textLight }}>{nomeProj[t.projeto_id]||''}</span>
                  </div>
                ))}
              </div>}
            </div>
          )}
        </div>
        );
      })()}

      {/* ABA PROJETOS - LISTA (quando nenhum projeto aberto) */}
      {tab==='projetos' && !projAberto && subProj==='fases' && (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {mktProjetos.length===0 && <div style={{ padding:40, textAlign:'center', color:C.textLight, background:C.white, borderRadius:12, border:"1px solid "+C.border }}>Sem projetos. Clica em "+ Novo projeto" para criar.</div>}
          {mktProjetos.map(p=>(
            <div key={p.id} style={{ background:C.white, border:"1px solid "+C.border, borderRadius:10, padding:'14px 18px', display:'flex', alignItems:'center', gap:14 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:15, fontWeight:700, color:C.text }}>{p.nome}</div>
                <div style={{ fontSize:12, color:C.textLight, marginTop:3 }}>{p.responsavel?`${p.responsavel} · `:''}{p.estado||'Ativo'}{p.prazo_termino?` · até ${new Date(p.prazo_termino).toLocaleDateString('pt-PT')}`:''}</div>
                {p.descricao && <div style={{ fontSize:12, color:C.textMid, marginTop:4 }}>{p.descricao}</div>}
              </div>
              <button onClick={()=>abrirProjeto(p)} style={btnP}>Abrir</button>
              <button onClick={()=>setDraftProj(p)} style={btnS}>Editar</button>
              <button onClick={()=>apagarProj(p.id)} style={{ ...btnS, color:'#C0392B' }}>Arquivar</button>
            </div>
          ))}
        </div>
      )}

      {/* ABA CAC & FUNIL */}
      {tab==='cac' && (
        <div>
          <div style={{ display:'flex', gap:10, marginBottom:14, flexWrap:'wrap' }}>
            <Card label="Investimento" valor={(cacData.tot.investimento||0).toLocaleString('pt-PT')+' EUR'} cor={C.purpleDark} />
            <Card label="Cliques" valor={cacData.tot.cliques} cor={C.blue} />
            <Card label="Leads" valor={cacData.tot.leads} cor={C.purple} />
            <Card label="Contratos" valor={cacData.tot.contratos} cor={C.green} />
            <Card label="CAC" valor={cacData.tot.cac!=null ? Math.round(cacData.tot.cac).toLocaleString('pt-PT')+' EUR' : '—'} cor={C.pink} />
          </div>

          {/* Funil */}
          <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:18, marginBottom:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:C.textMid, textTransform:'uppercase', marginBottom:14 }}>Funil de conversão</div>
            <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
              <Funil label="Cliques" v={cacData.tot.cliques} cor={C.blue} />
              <Seta pct={cacData.tot.clkLead} />
              <Funil label="Leads" v={cacData.tot.leads} cor={C.purple} />
              <Seta pct={cacData.tot.leadCont} />
              <Funil label="Contratos" v={cacData.tot.contratos} cor={C.green} />
            </div>
          </div>

          {/* Tabela por campanha */}
          <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, overflow:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead><tr style={{ background:C.bg, textAlign:'left' }}>
                {['Campanha','Cliques','Leads','Contratos','Investimento','CAC','Clk→Lead','Lead→Contr.'].map(h=>
                  <th key={h} style={{ padding:'8px 12px', color:C.textMid, fontWeight:700, fontSize:10, textTransform:'uppercase' }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {cacData.linhas.length===0 && <tr><td colSpan={8} style={{ padding:20, textAlign:'center', color:C.textLight }}>Sem campanhas com dados neste mês.</td></tr>}
                {cacData.linhas.map(r=>(
                  <tr key={r.id} style={{ borderTop:"1px solid "+C.border }}>
                    <td style={{ padding:'8px 12px', fontWeight:600 }}>{r.nome}</td>
                    <td style={{ padding:'8px 12px', color:C.textMid }}>{r.cliques}</td>
                    <td style={{ padding:'8px 12px', color:C.textMid }}>{r.leads}</td>
                    <td style={{ padding:'8px 12px', color:C.green, fontWeight:700 }}>{r.contratos}</td>
                    <td style={{ padding:'8px 12px', color:C.textMid }}>{(r.investimento||0).toLocaleString('pt-PT')} EUR</td>
                    <td style={{ padding:'8px 12px', color:C.pink, fontWeight:700 }}>{r.cac!=null ? Math.round(r.cac).toLocaleString('pt-PT')+' EUR' : '—'}</td>
                    <td style={{ padding:'8px 12px', color:C.textMid }}>{r.clkLead!=null ? r.clkLead+'%' : '—'}</td>
                    <td style={{ padding:'8px 12px', color:C.textMid }}>{r.leadCont!=null ? r.leadCont+'%' : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* MODAL LEAD */}
      {draftLead && (
        <Modal titulo={draftLead.id?'Editar lead':'Nova lead'} onClose={()=>setDraftLead(null)} onSave={salvarLead}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div><label style={lbl}>Data</label><input style={inp} type="date" value={draftLead.data||''} onChange={e=>setDraftLead({...draftLead,data:e.target.value})}/></div>
            <div><label style={lbl}>Estado</label><select style={inp} value={draftLead.estado||'nova'} onChange={e=>setDraftLead({...draftLead,estado:e.target.value})}>{Object.keys(ESTADOS_LEAD).map(k=><option key={k} value={k}>{ESTADOS_LEAD[k].label}</option>)}</select></div>
            {draftLead.estado==='perdida' && (
              <div style={{ gridColumn:'1 / 3', background:C.redLight, border:'1px solid '+C.red, borderRadius:8, padding:'10px 12px' }}>
                <label style={{ ...lbl, color:C.red }}>Motivo da perda (obrigatório)</label>
                <textarea style={{ ...inp, minHeight:56, borderColor:C.red }} autoFocus placeholder="ex.: preço, foi para concorrente, deixou de responder, sem orçamento…" value={draftLead.motivo_perda||''} onChange={e=>setDraftLead({...draftLead,motivo_perda:e.target.value})}/>
              </div>
            )}
            <div><label style={lbl}>Empresa</label><input style={inp} value={draftLead.empresa||''} onChange={e=>setDraftLead({...draftLead,empresa:e.target.value})}/></div>
            <div><label style={lbl}>Contacto</label><input style={inp} value={draftLead.contacto||''} onChange={e=>setDraftLead({...draftLead,contacto:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Página / URL de conversão</label><input style={inp} value={draftLead.pagina||''} onChange={e=>setDraftLead({...draftLead,pagina:e.target.value})}/></div>
            <div><label style={lbl}>Origem</label><input style={inp} value={draftLead.origem||''} onChange={e=>setDraftLead({...draftLead,origem:e.target.value})}/></div>
            <div><label style={lbl}>Campanha</label><select style={inp} value={draftLead.campanha_id||''} onChange={e=>setDraftLead({...draftLead,campanha_id:e.target.value||null})}><option value="">— nenhuma —</option>{campanhas.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}</select></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Notas</label><textarea style={{ ...inp, minHeight:60 }} value={draftLead.notas||''} onChange={e=>setDraftLead({...draftLead,notas:e.target.value})}/></div>
          </div>
        </Modal>
      )}

      {/* MODAL CAMPANHA */}
      {draftCamp && (
        <Modal titulo={draftCamp.id?'Editar campanha':'Nova campanha'} onClose={()=>setDraftCamp(null)} onSave={salvarCamp}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Nome da campanha</label><input style={inp} value={draftCamp.nome||''} onChange={e=>setDraftCamp({...draftCamp,nome:e.target.value})}/></div>
            <div><label style={lbl}>Data de lançamento</label><input style={inp} type="date" value={draftCamp.data_lancamento||''} onChange={e=>setDraftCamp({...draftCamp,data_lancamento:e.target.value})}/></div>
            <div><label style={lbl}>Canal</label><input style={inp} placeholder="Google Ads, LinkedIn…" value={draftCamp.canal||''} onChange={e=>setDraftCamp({...draftCamp,canal:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>URL da landing page</label><input style={inp} value={draftCamp.url||''} onChange={e=>setDraftCamp({...draftCamp,url:e.target.value})}/></div>
            <div><label style={lbl}>Área</label><input style={inp} placeholder="Bem-estar, Saúde…" value={draftCamp.area||''} onChange={e=>setDraftCamp({...draftCamp,area:e.target.value})}/></div>
            <div><label style={lbl}>Cliques</label><input style={inp} type="number" value={draftCamp.cliques||''} onChange={e=>setDraftCamp({...draftCamp,cliques:e.target.value})}/></div>
            <div><label style={lbl}>Investimento (€)</label><input style={inp} type="number" value={draftCamp.investimento||''} onChange={e=>setDraftCamp({...draftCamp,investimento:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Notas</label><textarea style={{ ...inp, minHeight:60 }} value={draftCamp.notas||''} onChange={e=>setDraftCamp({...draftCamp,notas:e.target.value})}/></div>
          </div>
        </Modal>
      )}

      {draftProj && (
        <Modal titulo={draftProj.id?'Editar projeto':'Novo projeto'} onClose={()=>setDraftProj(null)} onSave={salvarProj}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Nome do projeto</label><input style={inp} value={draftProj.nome||''} onChange={e=>setDraftProj({...draftProj,nome:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Responsáveis</label>
              <div style={{ display:'flex', gap:8 }}>
                {RESPONSAVEIS.map(nome=>{
                  const atuais = (draftProj.responsavel||'').split(',').map(x=>x.trim()).filter(Boolean);
                  const on = atuais.includes(nome);
                  return (
                  <div key={nome} onClick={()=>{ const set=new Set(atuais); if(on) set.delete(nome); else set.add(nome); setDraftProj({...draftProj, responsavel:[...set].join(', ')}); }}
                    style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 12px', borderRadius:8, border:"1px solid "+(on?C.purple:C.border), background:on?C.purpleLight:C.white, cursor:'pointer', fontSize:13, color:on?C.purple:C.text, fontWeight:on?700:400 }}>
                    <span>{on?'✓':'+'}</span>{nome}
                  </div>
                  );
                })}
              </div>
            </div>
            <div><label style={lbl}>Estado</label><select style={inp} value={draftProj.estado||'Ativo'} onChange={e=>setDraftProj({...draftProj,estado:e.target.value})}><option>Ativo</option><option>Em pausa</option><option>Concluído</option></select></div>
            <div><label style={lbl}>Prazo de término</label><input style={inp} type="date" value={draftProj.prazo_termino||''} onChange={e=>setDraftProj({...draftProj,prazo_termino:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}>
              <label style={{ display:'flex', alignItems:'flex-start', gap:9, cursor:'pointer', padding:'9px 11px',
                background: draftProj.usa_centros_custo ? C.purpleLight : C.bg, borderRadius:9,
                border:'1px solid '+(draftProj.usa_centros_custo ? C.purple : C.border) }}>
                <input type="checkbox" checked={!!draftProj.usa_centros_custo}
                  onChange={e=>setDraftProj({...draftProj, usa_centros_custo:e.target.checked})}
                  style={{ accentColor:C.purple, marginTop:2, cursor:'pointer' }}/>
                <span>
                  <span style={{ fontSize:13, fontWeight:700, color: draftProj.usa_centros_custo ? C.purple : C.text }}>
                    Repartir por centros de custo</span>
                  <span style={{ display:'block', fontSize:11.5, color:C.textLight, marginTop:2, lineHeight:1.5 }}>
                    Para projetos em que as despesas são imputadas a centros com orçamento próprio.
                    Os centros definem-se depois, no separador Financeiro do projeto.</span>
                </span>
              </label>
            </div>
            <div><label style={lbl}>Orçamento do evento (€)</label><input style={inp} type="number" step="0.01" placeholder="valor para jogar" value={ (draftProj.orcamento==null?'':draftProj.orcamento)} onChange={e=>setDraftProj({...draftProj,orcamento:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Faturas deste evento — série ou palavras (separadas por vírgulas)</label>
              <input style={inp} placeholder="ex.: WBG2026, Wellbeing Games, Food Zone" value={draftProj.faturas_regra||''} onChange={e=>setDraftProj({...draftProj, faturas_regra:e.target.value})}/>
              <div style={{ fontSize:11, color:C.textLight, marginTop:3 }}>As faturas importadas do TOC com esta série ou estas palavras ficam ligadas a este evento.</div></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Descrição</label><textarea style={{ ...inp, minHeight:60 }} value={draftProj.descricao||''} onChange={e=>setDraftProj({...draftProj,descricao:e.target.value})}/></div>
          </div>
        </Modal>
      )}

      {draftTarefa && (
        <Modal titulo={draftTarefa.id?'Editar tarefa':'Nova tarefa'} onClose={()=>setDraftTarefa(null)} onSave={salvarTarefa}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Tarefa</label><input style={inp} value={draftTarefa.texto||''} onChange={e=>setDraftTarefa({...draftTarefa,texto:e.target.value})}/></div>
            <div><label style={lbl}>Data (opcional)</label><input style={inp} type="date" value={draftTarefa.data_lembrete||''} onChange={e=>setDraftTarefa({...draftTarefa,data_lembrete:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Responsáveis</label>
              <div style={{ display:'flex', gap:8 }}>
                {RESPONSAVEIS.map(nome=>{
                  const atuais = (draftTarefa.responsavel_nome||'').split(',').map(x=>x.trim()).filter(Boolean);
                  const on = atuais.includes(nome);
                  return (
                  <div key={nome} onClick={()=>{ const set=new Set(atuais); if(on) set.delete(nome); else set.add(nome); setDraftTarefa({...draftTarefa, responsavel_nome:[...set].join(', ')}); }}
                    style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 12px', borderRadius:8, border:"1px solid "+(on?C.purple:C.border), background:on?C.purpleLight:C.white, cursor:'pointer', fontSize:13, color:on?C.purple:C.text, fontWeight:on?700:400 }}>
                    <span>{on?'✓':'+'}</span>{nome}
                  </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal>
      )}

      {draftFase && (
        <Modal titulo={draftFase.id?'Editar fase':'Nova fase'} onClose={()=>setDraftFase(null)} onSave={salvarFase}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Nome da fase</label><input style={inp} value={draftFase.nome||''} onChange={e=>setDraftFase({...draftFase,nome:e.target.value})}/></div>
            <div><label style={lbl}>Estado</label><select style={inp} value={draftFase.estado||'Por iniciar'} onChange={e=>setDraftFase({...draftFase,estado:e.target.value})}><option>Por iniciar</option><option>Em curso</option><option>Feito</option></select></div>
            <div><label style={lbl}>Prazo</label><input style={inp} type="date" value={draftFase.prazo||''} onChange={e=>setDraftFase({...draftFase,prazo:e.target.value})}/></div>
            <div><label style={lbl}>Ordem</label><input style={inp} type="number" value={draftFase.ordem||0} onChange={e=>setDraftFase({...draftFase,ordem:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Responsáveis</label>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {RESPONSAVEIS.map(nome=>{
                  const atuais = (draftFase.responsavel_nome||'').split(',').map(x=>x.trim()).filter(Boolean);
                  const on = atuais.includes(nome);
                  return (
                  <div key={nome} onClick={()=>{ const set=new Set(atuais); if(on) set.delete(nome); else set.add(nome); setDraftFase({...draftFase, responsavel_nome:[...set].join(', ')}); }}
                    style={{ display:'flex', alignItems:'center', gap:6, padding:'7px 12px', borderRadius:8, border:"1px solid "+(on?C.purple:C.border), background:on?C.purpleLight:C.white, cursor:'pointer', fontSize:13, color:on?C.purple:C.text, fontWeight:on?700:400 }}>
                    <span>{on?'✓':'+'}</span>{nome}
                  </div>
                  );
                })}
              </div>
            </div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Notas</label><textarea style={{ ...inp, minHeight:60 }} value={draftFase.notas||''} onChange={e=>setDraftFase({...draftFase,notas:e.target.value})}/></div>
          </div>
        </Modal>
      )}

      {draftCentro && (
        <Modal titulo={draftCentro.id?'Editar centro de custo':'Novo centro de custo'}
          onClose={()=>setDraftCentro(null)} onSave={salvarCentro}>
          <div><label style={lbl}>Nome</label>
            <input style={inp} value={draftCentro.nome||''} autoFocus
              placeholder="ex.: Mind · Vitality · Estrutura"
              onChange={e=>setDraftCentro({...draftCentro, nome:e.target.value})}/></div>
          <div style={{ marginTop:10 }}><label style={lbl}>Orçamento (€)</label>
            <input style={inp} type="number" step="0.01" value={draftCentro.orcamento ?? ''}
              placeholder="deixa vazio se não houver limite"
              onChange={e=>setDraftCentro({...draftCentro, orcamento:e.target.value})}/></div>
          {draftCentro.id && (
            <button onClick={apagarCentro}
              style={{ marginTop:14, background:C.redLight, border:'none', color:C.red, borderRadius:8,
                padding:'8px 14px', fontSize:12.5, cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>
              Apagar centro</button>
          )}
        </Modal>
      )}

      {draftMov && (
        <Modal titulo={draftMov.id?'Editar movimento':'Novo movimento'} onClose={()=>{ setDraftMov(null); setNovaRubrica(''); }} onSave={salvarMov}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Tipo</label>
              <div style={{ display:'flex', gap:8 }}>
                {[['despesa','Despesa'],['receita','Receita (parceiro)']].map(([v,l])=>{
                  const on = draftMov.tipo===v;
                  return (
                  <div key={v} onClick={()=>setDraftMov({...draftMov, tipo:v})}
                    style={{ flex:1, textAlign:'center', padding:'8px 12px', borderRadius:8, border:"1px solid "+(on?(v==='despesa'?C.red:C.green):C.border), background:on?(v==='despesa'?C.redLight:C.greenLight):C.white, cursor:'pointer', fontSize:13, fontWeight:on?700:400, color:on?(v==='despesa'?C.red:C.green):C.text }}>
                    {l}
                  </div>
                  );
                })}
              </div>
            </div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Estado</label>
              <div style={{ display:'flex', gap:8 }}>
                {[['previsto','Previsto (orçamentado)'],['realizado','Realizado']].map(([v,l])=>{
                  const on = (draftMov.estado||'realizado')===v;
                  return (
                  <div key={v} onClick={()=>setDraftMov({...draftMov, estado:v})}
                    style={{ flex:1, textAlign:'center', padding:'8px 12px', borderRadius:8, border:(v==='previsto'&&on?'1px dashed '+C.amber:"1px solid "+(on?C.purple:C.border)), background:on?(v==='previsto'?C.amberLight:C.purpleLight):C.white, cursor:'pointer', fontSize:13, fontWeight:on?700:400, color:on?(v==='previsto'?C.amber:C.purple):C.text }}>
                    {l}
                  </div>
                  );
                })}
              </div>
            </div>
            {draftMov.tipo==='despesa' ? (
              <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Rubrica</label>
                <select style={inp} value={draftMov.rubrica||''} onChange={e=>setDraftMov({...draftMov, rubrica:e.target.value})}>
                  <option value="">— escolhe —</option>
                  {rubricas.map(r=><option key={r.id} value={r.nome}>{r.nome}</option>)}
                  <option value="__nova__">+ Nova rubrica…</option>
                </select>
                {draftMov.rubrica==='__nova__' && <input style={{ ...inp, marginTop:8 }} placeholder="nome da nova rubrica" value={novaRubrica} onChange={e=>setNovaRubrica(e.target.value)} autoFocus/>}
                <div style={{ marginTop:10 }}><label style={lbl}>Fornecedor (opcional)</label><input style={inp} placeholder="ex.: Catering XPTO" value={draftMov.parceiro||''} onChange={e=>setDraftMov({...draftMov, parceiro:e.target.value})}/></div>
                {projAberto?.usa_centros_custo && centros.length>0 && (
                  <div style={{ marginTop:10 }}>
                    <label style={lbl}>Centro de custo</label>
                    <select style={inp} value={draftMov.centro_custo_id||''}
                      onChange={e=>setDraftMov({...draftMov, centro_custo_id:e.target.value||null})}>
                      <option value="">— por atribuir —</option>
                      {centros.map(cc=><option key={cc.id} value={cc.id}>{cc.nome}</option>)}
                    </select>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ gridColumn:'1 / 3', display:'grid', gridTemplateColumns:'2fr 1fr', gap:10 }}>
                <div><label style={lbl}>Quem paga (cliente ou parceiro)</label><input style={inp} placeholder="ex.: ANA Aeroportos" value={draftMov.parceiro||''} onChange={e=>setDraftMov({...draftMov, parceiro:e.target.value})}/></div>
                <div><label style={lbl}>Tipo de receita</label>
                  <select style={inp} value={draftMov.rubrica && ['Bilheteira','Espaço empresa','Patrocínio','Fee','Outra'].includes(draftMov.rubrica) ? draftMov.rubrica : 'Bilheteira'} onChange={e=>setDraftMov({...draftMov, rubrica:e.target.value})}>
                    {['Bilheteira','Espaço empresa','Patrocínio','Fee','Outra'].map(t => <option key={t} value={t}>{t}</option>)}
                  </select></div>
                <div style={{ gridColumn:'1 / 3', fontSize:11, color:C.textLight }}>Fica prevista até a fatura chegar do TOC e ser paga — liga-se sozinha à fatura do mesmo cliente com o mesmo valor.</div>
              </div>
            )}
            <div><label style={lbl}>Valor (€)</label><input style={inp} type="number" step="0.01" value={ (draftMov.valor==null?'':draftMov.valor)} onChange={e=>setDraftMov({...draftMov, valor:e.target.value})}/></div>
            <div><label style={lbl}>Data (opcional)</label><input style={inp} type="date" value={draftMov.data||''} onChange={e=>setDraftMov({...draftMov, data:e.target.value})}/></div>
            <div style={{ gridColumn:'1 / 3' }}><label style={lbl}>Descrição (opcional)</label><input style={inp} placeholder="ex.: aluguer do palco, patrocínio ouro…" value={draftMov.descricao||''} onChange={e=>setDraftMov({...draftMov, descricao:e.target.value})}/></div>
          </div>
        </Modal>
      )}
    </div>
  );
}

function Card({ label, valor, cor }){
  return (
    <div style={{ background:C.white, borderRadius:12, border:"1px solid "+C.border, padding:'11px 14px', flex:1, minWidth:120 }}>
      <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase', letterSpacing:.3 }}>{label}</div>
      <div style={{ fontSize:22, fontWeight:800, color:cor, marginTop:2 }}>{valor}</div>
    </div>
  );
}
function Mini({ label, v, cor }){
  return (
    <div style={{ flex:1 }}>
      <div style={{ fontSize:10, color:C.textLight, fontWeight:700, textTransform:'uppercase' }}>{label}</div>
      <div style={{ fontSize:17, fontWeight:800, color:cor||C.text }}>{v}</div>
    </div>
  );
}
function Funil({ label, v, cor }){
  return (
    <div style={{ flex:1, minWidth:90, textAlign:'center', background:cor+'18', border:'1px solid '+cor, borderRadius:10, padding:'14px 8px' }}>
      <div style={{ fontSize:26, fontWeight:800, color:cor }}>{v}</div>
      <div style={{ fontSize:11, fontWeight:700, color:C.textMid, textTransform:'uppercase' }}>{label}</div>
    </div>
  );
}
function Seta({ pct }){
  return (
    <div style={{ textAlign:'center', minWidth:60, color:C.textLight }}>
      <div style={{ fontSize:18 }}>→</div>
      <div style={{ fontSize:12, fontWeight:700, color:C.purple }}>{pct!=null ? pct+'%' : '—'}</div>
    </div>
  );
}
function Modal({ titulo, children, onClose, onSave }){
  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(26,26,46,.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:C.white, borderRadius:14, padding:24, width:'100%', maxWidth:560, maxHeight:'88vh', overflow:'auto', fontFamily:F }}>
        <h2 style={{ margin:'0 0 18px', fontSize:19, fontWeight:800, color:C.purple }}>{titulo}</h2>
        {children}
        <div style={{ display:'flex', gap:10, marginTop:20, justifyContent:'flex-end' }}>
          <button onClick={onClose} style={btnS}>Cancelar</button>
          <button onClick={onSave} style={btnP}>Guardar</button>
        </div>
      </div>
    </div>
  );
}
